module.exports = __webpack_public_path__ + "img/esd-needle-min.f33fcc69.jpg";